// @core/api/endpoints/bootstrap/save_platform_identity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SavePlatformIdentityRequest,
  SavePlatformIdentityResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Save platform identity
 * Saves platform name, slug, domain, and data residency settings. Validates slug format.
 * @public This endpoint does not require authentication
 */
export async function SavePlatformIdentity(
  data: SavePlatformIdentityRequest,
  options?: RequestOptions
): Promise<SavePlatformIdentityResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps/identity`;
  const requestOptions = { ...options, skipAuth: true };
  return client.put<SavePlatformIdentityResponse>(requestPath, data, requestOptions);
}
